import React from "react";

const FamilyTreeNoMember = () => {
  return (
    <div className="blank-data-div">
      <div className="empty-events-state text-center">
        <img
          src={window.getPublicUrl("/assets/images/member-blank.png")}
          alt="No events"
          className="empty-events-img mx-auto my-0"
        />
        <p className="empty-events-text mb-2">Please search any family member.</p>
      </div> 
    </div>
  );
};

export default FamilyTreeNoMember;
